import { CommonCalendarQueryParams } from './entities';

export type CalendarApiParameters = Record<string, string | number | boolean | undefined> & {
  action?: string;
  analyst?: string;
  analyst_id?: string;
  country?: string;
  date?: string;
  date_from?: string;
  date_search_field?: string;
  date_sort?: string;
  date_search_strict?: boolean;
  date_to?: string;
  dividend_yield?: number;
  dividend_yield_operation?: string;
  event_name?: string;
  event_type?: string;
  firm?: string;
  firm_id?: string;
  importance?: number;
  ipo_type?: string;
  is_primary?: boolean;
  securities?: string;
  tickers?: string;
  updated?: number;
};

export interface CalendarApiParams {
  country?: string;
  event_category?: string;
  event_name?: string;
  fields?: string;
  page?: number;
  pagesize?: number;
  parameters?: CalendarApiParameters;
  token?: string;
}

export const genUrlParams = (params: CommonCalendarQueryParams): CalendarApiParams => {
  const { date, dateFrom, dateSort, dateTo, fields, id, importance, page, pageSize, symbols, updated } = params;

  return {
    ...(fields && { fields }),
    ...(page !== undefined && { page }),
    ...(pageSize && { pagesize: pageSize }),
    parameters: {
      ...(date && { date }),
      ...(id && { id }),
      ...(dateFrom && { date_from: dateFrom }),
      ...(dateSort && { date_sort: dateSort }),
      ...(dateTo && { date_to: dateTo }),
      ...(importance !== undefined && { importance }),
      ...(updated !== undefined && { updated }),
      ...(symbols?.length && { tickers: symbols.join(',') }),
    },
  };
};

export type UrlParamsTransformer<T extends CommonCalendarQueryParams> = (params: T) => CalendarApiParams;
